// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function label(value) {
  if (value === "CONDO") {
    return "Condo/Townhouse";
  } else {
    return "Single-family";
  }
}

function make(value) {
  return {
    label: label(value),
    value: value
  };
}

function getOptionLabel(option) {
  return option.label;
}

function getOptionValue(option) {
  return option.value;
}

let defaultOptions = [
  "SINGLE_FAMILY",
  "CONDO"
].map(make);

let Option = {
  make: make,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  defaultOptions: defaultOptions
};

exports.label = label;
exports.Option = Option;
/* defaultOptions Not a pure module */
